import { Button } from '@/components/base/button'
import { Dialog, DialogActions, DialogBody, DialogTitle, ShowProps } from '@/components/base/dialog'
import { Divider } from '@/components/base/divider'
import { useEffect, useState } from 'react'
import { CustomFieldQuery } from './__generated__/show_query'
import { Query } from './show_query'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'
import { Accordion } from '@/components/accordion'
import { DeleteDialog } from '@/components/delete_dialog'
import { Mutation as DeleteMutation } from './delete_mutation'
import { Query as TableQuery } from './table_query'
import { EditDialog } from './edit_dialog'
import { CustomFieldField } from '@/types'

type CustomField = CustomFieldQuery['customFields']['nodes'][0]

export const ShowDialog = ({ id, open, setOpen }: ShowProps) => {
  const [openEdit, setOpenEdit] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [customField, setCustomField] = useState<CustomField | null>(null)

  const { data, loading, error } = useQuery<CustomFieldQuery>(Query, { variables: { filters: { idEq: id } } })

  useEffect(() => {
    if (!data || !id) { return }

    setCustomField(data.customFields.nodes[0])
  }, [id, data])

  const onEdit = () => {
    setOpenEdit(true)
  }
  const onDelete = () => {
    setOpenDelete(true)
  }

  const onDeleteSuccess = () => {
    setOpenDelete(false)
    setOpen(false)
  }

  return (
    <>
      <Dialog open={open} size="7xl" onClose={() => setOpen(false)}>
        <DialogTitle>
          { loading || !customField
            ? <Loading />
            : <div className="flex flex-row justify-between">
              <span className="flex flex-row gap-4 items-center pb-6">
                { customField.name }
              </span>
            </div> }
        </DialogTitle>
        <DialogBody>
          { error && <Error message={error.message} />}
          { customField && <div className="flex flex-col gap-4">
            <div className="grid grid-cols-4 items-center align-center" />
            <Divider />
            { customField.fieldType == CustomFieldField.Select && <Accordion title="Options">
              <p>Boo</p>
            </Accordion> }
          </div> }
        </DialogBody>
        <DialogActions>
          { customField && <Button color="amber" onClick={onEdit}>Edit</Button> }
          { customField && <Button color="red" onClick={onDelete}>Delete</Button> }
        </DialogActions>
      </Dialog>
      { customField && <EditDialog id={customField.id} open={openEdit} setOpen={setOpenEdit} /> }
      {
        customField &&
          <DeleteDialog
            id={customField.id}
            mutation={DeleteMutation}
            open={openDelete}
            refetchQueries={[TableQuery]}
            setOpen={setOpenDelete}
            onSuccess={onDeleteSuccess}
          />
      }
    </>
  )
}
